import { render, staticRenderFns } from "./CandidateSkillDetails.vue?vue&type=template&id=193a0ab9&"
import script from "./CandidateSkillDetails.vue?vue&type=script&lang=js&"
export * from "./CandidateSkillDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports